/**
 * The project's decisions and open questions across every page
 * (`project/:p/marks[?kind=decided|open]`), where a placed marks list's
 * console link lands. Drawn by the same embed a page places, from the team's
 * marks index the Pages session installs. That index leaves typed-page bodies
 * out, which the page says.
 */
import { lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { loadPlacedViewEmbed } from '@nimbalyst/collab-bundle/editor';
import { useDocsShell } from '../collab/CollabDocsShell';
import { pageUriPath } from './pagesLinks';

const PlacedViewEmbed = lazy(() => loadPlacedViewEmbed().then((module) => ({ default: module.PlacedViewEmbed })));

const TITLES = { all: 'Decisions and open questions', decided: 'Decisions', open: 'Open questions' } as const;

export function WebMarksListRoute() {
  const { team, projectId, navigate } = useDocsShell();
  const [params] = useSearchParams();
  const kind = params.get('kind');
  const marks = kind === 'decided' || kind === 'open' ? kind : 'all';
  return (
    <div className="web-marks-list px-8 py-6" data-testid="web-marks-list">
      <h1 className="m-0 mb-4 text-2xl font-semibold text-nim">{TITLES[marks]}</h1>
      <Suspense fallback={null}>
        <PlacedViewEmbed
          target={{ kind: 'marks', marks }}
          label={TITLES[marks]}
          attrs={{}}
          onOpenPage={(uri) => {
            const path = pageUriPath(uri, team, projectId);
            if (path) navigate(path);
          }}
        />
      </Suspense>
    </div>
  );
}
